import React from "react";
import { CheckCircle2, Clock, Users } from "lucide-react";
import { Badge } from "../../ui/badge";
import { MultiApprovalRuleProgress } from "./Api/multiapprovalapi";

interface MultiApprovalProgressPanelProps {
  ruleProgress: MultiApprovalRuleProgress[];
  compact?: boolean;
}

export default function MultiApprovalProgressPanel({
  ruleProgress,
  compact = false,
}: MultiApprovalProgressPanelProps) {
  if (!ruleProgress.length) {
    return null;
  }

  return (
    <div className={`space-y-3 ${compact ? "mt-2" : "mt-3"}`}>
      <div className="flex items-center gap-2 text-xs font-medium text-slate-600 dark:text-slate-300">
        <Users className="w-3.5 h-3.5" />
        Multi-Approval Progress
      </div>
      {ruleProgress.map((group) => (
        <div
          key={group.groupUuid}
          className="p-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/50"
        >
          <div className="flex items-center justify-between gap-2 mb-2">
            <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">
              {group.groupName}
            </span>
            <Badge
              variant="outline"
              className={
                group.status === "COMPLETED"
                  ? "text-green-700 border-green-300 bg-green-50 dark:bg-green-950/30 dark:text-green-300"
                  : "text-amber-700 border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:text-amber-300"
              }
            >
              {group.status === "COMPLETED" ? (
                <>
                  <CheckCircle2 className="w-3 h-3 mr-1" />
                  Completed
                </>
              ) : (
                <>
                  <Clock className="w-3 h-3 mr-1" />
                  Pending
                </>
              )}
            </Badge>
          </div>

          {group.status === "COMPLETED" ? (
            <p className="text-xs text-green-700 dark:text-green-300">
              Approval completed ({group.currentApprovals}/{group.requiredApprovals})
            </p>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-2 mb-2 text-xs text-slate-600 dark:text-slate-400">
                <span>Required: {group.requiredApprovals}</span>
                <span>
                  Approved: {group.currentApprovals}/{group.requiredApprovals}
                </span>
              </div>
              {group.currentUserApproved && (
                <p className="flex items-center gap-1 mb-1 text-xs text-green-700 dark:text-green-300">
                  <CheckCircle2 className="w-3 h-3 shrink-0" />
                  You already approved
                </p>
              )}
              {group.userMessage && (
                <p className="text-xs text-slate-600 dark:text-slate-400">{group.userMessage}</p>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
}
